const config = {};
config.readablePath = "production"; // ***** Change for the respective environment (pre/integration/production)
config.APP_NAME = 'uclfantasy';
config.AUTH_COOKIE = 'UCL_CLASSIC_007';
config.COOKIE_GM = 'UCL_CLASSIC_RAW';
config.seasonCookieName = 'VISITED_SEASONS';
config.lastSeason = '16-17';
config.currentSeason = '17-18';
config.teamDataLocalStorageName = 'teamDataSeason2';// to be changed for every season
config.MAX_PLAYERS_PER_TEAM = 15;
config.MAX_COUNT_FOR_PERCENTAGE = 17;
config.MIN_TEAM_NAME_LENGTH = 3;
config.MAX_TEAM_NAME_LENGTH = 24;
config.MIN_LEAGUE_NAME_LENGTH = 3;
config.MAX_LEAGUE_NAME_LENGTH = 24;
config.MAX_LEAGUE_CODE_LENGTH = 24;
config.MEMBERS_COUNT_REQUIRED_FOR_ACHIEVEMENTS = 5;
config.MIXED_API_INTERVAL_START_TIME = 5;
config.MIXED_API_INTERVAL_DURATION = 15;
config.MIXED_API_BEFORE_INTERVAL_DURATION = 60;
config.TEAM_LOCK_SCREEN_CLOSE_TIMEOUT = 5;
config.TEAM_LOCK_TOAST_CHECK_INTERVAL = 60;
config.TIME_DIFF_TO_CONSIDER = -5;
config.lang = {
    'English': 'en',
    'Spanish': 'es',
    'French': 'fr',
    'German': 'de',
    'Portugese': 'pt',
    'Russian': 'ru',
    'Italian': 'it'
};
config.HELP_URL = 'https://helpcenter.uefa.com/hc/en-gb/sections/115001652769-Fantasy';
config.RULES_URL = 'https://www.uefa.com/news/newsid=2396425.html';
// config.PS4_URL = 'https://www.playstation.com/ps4/?emcid=di-br-131143';
// config.PS5_URL = 'https://www.playstation.com/ps5/';
config.PS5Obj = {
    'en': 'https://www.playstation.com/en-gb/ps5/?emcid=di-ot-253017',
    'fr': 'https://www.playstation.com/fr-fr/ps5/?emcid=di-ot-253018',
    'de': 'https://www.playstation.com/de-de/ps5/?emcid=di-ot-253019',
    'es': 'https://www.playstation.com/es-es/ps5/?emcid=di-ot-253020',
    'it': 'https://www.playstation.com/it-it/ps5/?emcid=di-ot-253021',
    'pt': 'https://www.playstation.com/pt-pt/ps5/?emcid=di-ot-253022',
    'ru': 'https://www.playstation.com/ru-ru/ps5/?emcid=di-ot-253023'
}
config.article_id = {
    rules: {
        en: "https://gaming.uefa.com/news/025f-0fd4b42cc0a7-74498b7df63b-1000/?mobileview={{boolean}}",
        es: "https://gaming.uefa.com/news/025f-0fe2d6e94ea3-2644ad1749e9-1000/?mobileview={{boolean}}",
        fr: "https://gaming.uefa.com/news/025f-0fe2c838af3e-4502c7b2ebe7-1000/?mobileview={{boolean}}",
        de: "https://gaming.uefa.com/news/025f-0fe2ca1e0a2f-e4e9f5bec283-1000/?mobileview={{boolean}}",
        it: "https://gaming.uefa.com/news/025f-0fe2cd8ec96b-59710a23c6d1-1000/?mobileview={{boolean}}",
        pt: "https://gaming.uefa.com/news/025f-0fe2c67b2f72-8149c027c1de-1000/?mobileview={{boolean}}",
        ru: "https://gaming.uefa.com/news/025f-0fe3444021c9-8c634ca32f0c-1000/?mobileview={{boolean}}"
    },
    prizes: {
        en: "https://gaming.uefa.com/news/025f-0fd4b51510e8-9a324b5573e1-1000/?mobileview={{boolean}}",
        es: "https://gaming.uefa.com/news/025f-0fe2de73d25e-35d8f543f7e3-1000/?mobileview={{boolean}}",
        fr: "https://gaming.uefa.com/news/025f-0fe2ca51cadc-a8a91b2ca27e-1000/?mobileview={{boolean}}",
        de: "https://gaming.uefa.com/news/025f-0fe443b1a2c9-e4287e6d748b-1000/?mobileview={{boolean}}",
        it: "https://gaming.uefa.com/news/025f-0fe2c7abea92-4ee2b96a59d3-1000/?mobileview={{boolean}}",
        pt: "https://gaming.uefa.com/news/025f-0fe2d5e3e19e-51dda3b9ff4f-1000/?mobileview={{boolean}}",
        ru: "https://gaming.uefa.com/news/025f-0fe3483fb828-9e9e5043c763-1000/?mobileview={{boolean}}"
    }
};
config.headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'entity': 'ed0t4n$3!',
    'Access-Control-Expose-Headers': 'Date',
};
config.lang2D = Object.keys(config.lang).map(key => {
    return config.lang[key];
});
let subURL = window.location.href.split(window.location.host)[1];
let possibleLang = subURL.split('/').filter(Boolean)[0];
let defaultLanguage = 'en';
const DOMAIN = window.location.host;
config.CURRENT_LANGUAGE = (config.lang2D.indexOf(possibleLang) > -1) ? possibleLang : defaultLanguage;
config.PLATFORM_ID = '1';
config.TourId = window.location.host == 'gaming.uefa.com' ? '20' : '1';
// if (window.location.host == 'gaming.uefa.com') {
// Avoid `console` errors in browsers that lack a console.
(function () {
    let method;
    const noop = function () {
    };
    const methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    let length = methods.length;
    const console = (window.console = window.console || {});
    while (length--) {
        method = methods[length];
        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());
// }
config.BASE_DOMAIN = window.location.host;
config.BASE_URL = config.BASE_DOMAIN + config.CURRENT_LANGUAGE;
config.BASE_DIR = '/' + config.CURRENT_LANGUAGE + '/' + config.APP_NAME;
config.API_BASE_PATH = config.BASE_DIR + '/services/api/';
config.API_FEEDS_PATH = config.BASE_DIR + '/services/';
config.JsPath = config.BASE_DIR + '/static-assets/js'
config.playerImgBase = config.BASE_DIR + '/static-assets/images/';
config.dreamteamImgBase = config.BASE_DIR + '/static-assets/dreamteam/' + config.CURRENT_LANGUAGE + '/';

config.UEFAImgBase = 'https://img.uefa.com/imgml/TP/';
config.trend = {
    '0': null,
    '1': 'si-tie',
    '2': 'si-winner',
    '3': 'si-loser'
};
config.teamStatus = {
    hasTeam: 1,
    doesNotHaveTeam: 0
};
config.gameStatus = {
    "0": "pre",
    "1": "live",
    "2": "match_end",
    "3": "post"
};
config.liveMatchStatus = {
    isLive: 1,
    isFinished: 2
};
config.enumMatchStatus = {
    isUpComing: 0,
    isLock: 1,
    isFinished: 2
};
config.fixtureStatus = {
    isUpComing: 1,
    isLock: 2,
    isSubstitution: 3,
    isFinished: 4,
    isOpen: 5,
    isNewUser: 6,
};
config.liveFeedStatus = {
    upcoming: 0,
    finished: 1,
    live: 3,
};
config.liveAndFixtureStatusMap = {
    [config.liveFeedStatus.upcoming]: config.enumMatchStatus.isUpComing,
    [config.liveFeedStatus.finished]: config.enumMatchStatus.isFinished,
    [config.liveFeedStatus.live]: config.enumMatchStatus.isLock
};
config.skills = {
    3: {
        skill: 'Goal Keepers',
        key: 'GK',
        map: 1
    },
    2: {
        skill: 'Defenders',
        key: 'DEF',
        map: 2
    },
    1: {
        skill: 'Midfielders',
        key: 'MID',
        map: 3
    },
    0: {
        skill: 'Forwards',
        key: 'FWD',
        map: 4
    }
};

config.positionMap = {
    1: {
        skill: 'Goal Keepers',
        key: 'GK',
        map: 1,
        skillTrans: 'gkTxtLong'
    },
    2: {
        skill: 'Defenders',
        key: 'DEF',
        map: 2,
        skillTrans: 'defTxtLong'
    },
    3: {
        skill: 'Midfielders',
        key: 'MID',
        map: 3,
        skillTrans: 'midTxtLong'
    },
    4: {
        skill: 'Forwards',
        key: 'FWD',
        map: 4,
        skillTrans: 'fwdTxtLong'
    }
};

config.skillsFilter = [
    {
        skill: 'Goal Keepers',
        key: 'GK',
        map: 1
    },
    {
        skill: 'Defenders',
        key: 'DEF',
        map: 2
    },
    {
        skill: 'Midfielders',
        key: 'MID',
        map: 3
    },
    {
        skill: 'Forwards',
        key: 'FWD',
        map: 4
    }
];

config.skillsFilterWeb = [
    {
        skill: 'All',
        key: 'All',
        map: 0
    },
    {
        skill: 'Goal Keepers',
        key: 'GK',
        map: 1
    },
    {
        skill: 'Defenders',
        key: 'DEF',
        map: 2
    },
    {
        skill: 'Midfielders',
        key: 'MID',
        map: 3
    },
    {
        skill: 'Forwards',
        key: 'FWD',
        map: 4
    }
];

config.fillObj = {
    id: null,
    details: {},
    isBench: false,
    isHighlighted: false,
    isCaptain: false,
};
config.orderedPositions = [
    'forward',
    'midfielder',
    'defender',
    'goalkeeper'
];
config.EnumPosition = {
    'Goalkeepers': 1,
    'Defenders': 2,
    'Midfielders': 3,
    'Forwards': 4
};
config.pos = [4, 3, 2, 1];
config.EnumMinPositionNos = {};
config.EnumMinPositionNos[config.EnumPosition.Goalkeepers] = 1;
config.EnumMinPositionNos[config.EnumPosition.Defenders] = 3;
config.EnumMinPositionNos[config.EnumPosition.Midfielders] = 2;
config.EnumMinPositionNos[config.EnumPosition.Forwards] = 1;
config.EnumMaxPositionNosBench = {};
config.EnumMaxPositionNosBench[config.EnumPosition.Goalkeepers] = 1;
config.EnumMaxPositionNosBench[config.EnumPosition.Defenders] = 2;
config.EnumMaxPositionNosBench[config.EnumPosition.Midfielders] = 3;
config.EnumMaxPositionNosBench[config.EnumPosition.Forwards] = 2;
config.playerPos = ['GK', 'DEF', 'MID', 'FWD'];
// config.sortByArr = ['Value', 'SelPer', 'TotPts', 'GS', 'Assist', 'PE', 'PM', 'CS', 'GC', 'Saves', 'PS', 'OG', 'YC', 'RC', 'PC'];
// ['TotPts', 'lastGdPoints', 'Value', 'SelPer', 'AvgPlayerPts', 'AvgPlayerValue', 'GS', 'Assist', 'CS']
// config.sortByArr = ['TotPts', 'MWPts', 'AvgPlayerValue', 'SelPer', 'AvgPts', 'AvgVal', 'GS', 'Assist', 'CS'];
config.sortByArr = ['TotPts', 'lastGdPoints', 'Value', 'SelPer', 'AvgPlayerPts', 'AvgPlayerValue', 'GS', 'Assist', 'CS', 'BR', 'GOB'];
config.sortByArrTracking = {
    'TotPts': "Total points",
    'lastGdPoints': "Matchweek Points",
    'Value': "Price",
    'SelPer': "Selected by %",
    'AvgPlayerPts': "Average points",
    'AvgPlayerValue': "AvgPlayerValue",
    'GS': "Goals scored",
    'Assist': "Assists",
    'CS': "Clean sheets"
}
config.defaultSortBy = 'TotPts';
config.playerFilters = {
    sortBy: 'TotPts',
    searchString: '',
    teamIds: [],
    teamNamesObj: [],
    priceFilterSelected: [100],
    curPosFilter: 1,
    skillId: [],
    filterCount: 0,
    playerStatus: [{
        id: "I", trackLable: "Injured players", label: "injured", siIcon: "si-injured", active: false
    }, {
        id: "S", trackLable: "Suspended players", label: "suspended", siIcon: "si-suspended", active: false
    }],
    playerRecomendation: ["playerRecomendationdDefault"]

};
config.playerRecomendationTrans = {
    "Category1": "Predicted top scorers",
    "Category2": "Last season's top scorers",
    "Category3": "Most picked as captain",
    "Category4": "Most picked",
    "Category5": "Most Transferred in last 24hrs",
    "Category6": "",
    "Category7": "",
    "Category8": "",
    "Category9": "",
    "Category10": "",
    "Category11": "",
    "Category12": "",
    "Category13": "",
    "Category14": "",
    "Category15": ""
}

config.priceTrans = {
    "5": "€5m",
    "6": "€6m",
    "7": "€7m",
    "8": "€8m",
    "9": "€9m",
    "10": "€10m",
    "11": "€11m",
    "12": "€12m",
    "13": "€13m",
    "Unlimited": "Unlimited",
    "Affordable": "Affordable",
    "12.5": "€12.5m",
    "11.5": "€11.5m",
    "10.5": "€10.5m",
    "9.5": "€9.5m",
    "8.5": "€8.5m",
    "7.5": "€7.5m",
    "6.5": "€6.5m",
    "5.5": "€5.5m",
    "4.5": "€4.5m"
}
config.leaguesPageSize = 1000;
config.playerRecomendationDefault = "playerRecomendationdDefault"
config.MAX_FORMATION_COMP_ID = 9;
config.emptyValue = null;
config.recomendedListCount = 20;
config.knockoutGDID = 9;
config.publicLeaderBoardTypes = {
    'overall': 1,
    'country': 2,
    'club': 3,
    'knockout': 4
};
config.wildCardStatus = {
    'notStarted': 1,
    'startedAndNotUsed': 2,
    'usedInCurrent': 3,
    'usedInBefore': 4,
    'usedInCurrentTemp': 5
};
config.limitlessBoosterStatus = {
    'notStarted': 1,
    'startedAndNotUsed': 2,
    'usedInCurrent': 3,
    'usedInBefore': 4,
    'usedInCurrentTemp': 5
};
config.modes = {
    'view-manage-team': 1,
    'substitution': 2,
    'transfer': 3,
    'transfer-summary': 9,
};
config.possibleActions = {
    'substitution': 1,
    'transfer': 2,
    'subsAndTransfer': 3,
    'viewpoint': 4,
    'live': 5,
};
config.priceFilter = [
    // { id: 100, label: 'Unlimited', min: 0, max: 100, },
    // { id: 101, label: 'Affordable', min: 0, max: 0, },
    // { id: 18, label: '€13', min: 13, max: 100, },
    // { id: 17, label: '€12.5', min: 12.5, max: 100, },
    // { id: 16, label: '€12', min: 12, max: 100, },
    // { id: 15, label: '€11.5', min: 11.5, max: 100, },
    // { id: 14, label: '€11', min: 11, max: 100, },
    // { id: 13, label: '€10.5', min: 10.5, max: 100, },
    // { id: 12, label: '€10', min: 10, max: 100, },
    // { id: 11, label: '€9.5', min: 9.5, max: 100, },
    // { id: 10, label: '€9', min: 9, max: 100, },
    // { id: 9, label: '€8.5', min: 8.5, max: 100, },
    // { id: 8, label: '€8', min: 8, max: 100, },
    // { id: 7, label: '€7.5', min: 7.5, max: 100, },
    // { id: 6, label: '€7', min: 7, max: 100, },
    // { id: 5, label: '€6.5', min: 6.5, max: 100, },
    // { id: 4, label: '€6', min: 6, max: 100, },
    // { id: 3, label: '€5.5', min: 5.5, max: 100, },
    // { id: 2, label: '€5', min: 5, max: 8.9, },
    // { id: 1, label: '€4.5', min: 4.5, max: 6.9, },
    // { id: 0, label: '€4', min: 4, max: 4.9, },


];
config.priceFilterObj = {
    // 100: { id: 100, label: 'Unlimited', min: 0, max: 100, },
    // 101: { id: 101, label: 'Affordable', min: 0, max: 0, },
    // 18: { id: 18, label: '€13', min: 13, max: 100, },
    // 17: { id: 17, label: '€12.5', min: 12.5, max: 100, },
    // 16: { id: 16, label: '€12', min: 12, max: 100, },
    // 15: { id: 15, label: '€11.5', min: 11.5, max: 100, },
    // 14: { id: 14, label: '€11', min: 11, max: 100, },
    // 13: { id: 13, label: '€10.5', min: 10.5, max: 100, },
    // 12: { id: 12, label: '€10', min: 10, max: 100, },
    // 11: { id: 11, label: '€9.5', min: 9.5, max: 100, },
    // 10: { id: 10, label: '€9', min: 9, max: 100, },
    // 9: { id: 9, label: '€8.5', min: 8.5, max: 100, },
    // 8: { id: 8, label: '€8', min: 8, max: 100, },
    // 7: { id: 7, label: '€7.5', min: 7.5, max: 100, },
    // 6: { id: 6, label: '€7', min: 7, max: 100, },
    // 5: { id: 5, label: '€6.5', min: 6.5, max: 100, },
    // 4: { id: 4, label: '€6', min: 6, max: 100, },
    // 3: { id: 3, label: '€5.5', min: 5.5, max: 100, },
    // 2: { id: 2, label: '€5', min: 5, max: 8.9, },
    // 1: { id: 1, label: '€4.5', min: 4.5, max: 6.9, },
    // 0: { id: 0, label: '€4', min: 4, max: 4.9, },
};
const isMobile = () => {
    if (window.innerWidth > 768) {
        return false
    }
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
config.isMobile = isMobile();
/** Gamer Card  */
config.enumscinarioCode = {
    preUnkownFixture: 'TR_PRE_FIX_AN_0',
    preKownFixture: 'TR_PRE_FIX_AN_1',
    /*For Trans*/
    startOfMatchDayMoreThan6Hour: 'TR_STR_MD_LIN_AN_0',
    startOfMatchDayBefore6Hour: 'TR_STR_MD_HR_LIN_AN_0',
    preLineupsAnnounced: 'TR_STR_MD_HR_LIN_AN_1',
    /*For Subs*/
    startOfGameDayMoreThan6Hour: 'TR_STR_GD_LIN_AN_0',
    startOfGameDayBefore6Hour: 'TR_STR_GD_HR_LIN_AN_0',
    preLineupsAnnouncedSubs: 'TR_STR_GD_HR_LIN_AN_1',
    live: 'TR_LIVE',
    pointsBeingCalculated: 'TR_LIVE_PTSUB',
    pointsOk: 'TR_POINT_OK',
    endOfMatchDay: 'TR_STR_MD_END_PMD',
    longBreak: 'TR_LB_UNK_FIX',
    postTournament: 'TR_POST'
};
config.enumCard = {
    'Welcome_card': 'Welcome_card',
    'League_card': 'League_card',
    'Team_card': 'Team_card',
    'Banner': 'Banner',
    'Email_card': 'Email_card',
    'Newsletter_card': 'Newsletter_card',
    'Prizes_card': 'Prizes_card',
    'MD_status_card': 'MD_status_card',
    'MD_status_card': 'MD_status_card_eot',
    'Editorial_card': 'Editorial_card',
    'Dream_team_card': 'Dream_team_card',
    'Best_manager_card': 'Best_manager_card',
    'EOT_card': 'EOT_card',
    'Trans_And_Sub': 'Trans_And_Sub',
    'Dynamic_Cards': 'Dynamic_Cards',
};
let arrPreTornamentUnkownFixtureOrder = [

    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.League_card,
    config.enumCard.Team_card,
    config.enumCard.Banner,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrPreTornamentKownFixtureOrder = [

    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.Team_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.MD_status_card,
    config.enumCard.Editorial_card,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrStartOfMatchDayBefore6Hour = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Trans_And_Sub,
    config.enumCard.Welcome_card,
    config.enumCard.Team_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.MD_status_card,
    config.enumCard.Editorial_card,
    config.enumCard.Best_manager_card,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card,
];
let arrStartOfMatchDayMoreThan6Hour = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.Team_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.MD_status_card,
    config.enumCard.Editorial_card,
    config.enumCard.Best_manager_card,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrPreLineupsAnnounced = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.Team_card,
    config.enumCard.Editorial_card,
    config.enumCard.Banner,
    config.enumCard.League_card,
    config.enumCard.Email_card,
    config.enumCard.MD_status_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrLive = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Team_card,
    config.enumCard.Email_card,
    config.enumCard.Banner,
    config.enumCard.MD_status_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrPointsBeingCalculated = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Team_card,
    config.enumCard.MD_status_card,
    config.enumCard.Banner,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrPointsOk = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.MD_status_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.Team_card,
    config.enumCard.Best_manager_card,
    config.enumCard.Editorial_card,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrEndOfMatchDay = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.Trans_And_Sub,
    config.enumCard.Team_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.Editorial_card,
    config.enumCard.Dream_team_card,
    config.enumCard.Best_manager_card,
    config.enumCard.MD_status_card,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrLongBreak = [
    config.enumCard.Dynamic_Cards,
    config.enumCard.Welcome_card,
    config.enumCard.MD_status_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.Email_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Prizes_card];
let arrPostTournament = [
    config.enumCard.Dynamic_Cards,
    // config.enumCard.EOT_card,
    config.enumCard.League_card,
    config.enumCard.Banner,
    config.enumCard.MD_status_card_eot,
    config.enumCard.Dream_team_card,
    config.enumCard.Newsletter_card,
    config.enumCard.Best_manager_card,
];
config.objOrderHomeCard = {};
config.objOrderHomeCard[config.enumscinarioCode.preUnkownFixture] = arrPreTornamentUnkownFixtureOrder;
config.objOrderHomeCard[config.enumscinarioCode.preKownFixture] = arrPreTornamentKownFixtureOrder;
config.objOrderHomeCard[config.enumscinarioCode.startOfMatchDayBefore6Hour] = arrStartOfMatchDayBefore6Hour;
config.objOrderHomeCard[config.enumscinarioCode.startOfMatchDayMoreThan6Hour] = arrStartOfMatchDayMoreThan6Hour;
config.objOrderHomeCard[config.enumscinarioCode.preLineupsAnnounced] = arrPreLineupsAnnounced;
config.objOrderHomeCard[config.enumscinarioCode.startOfGameDayMoreThan6Hour] = arrStartOfMatchDayBefore6Hour;
config.objOrderHomeCard[config.enumscinarioCode.startOfGameDayBefore6Hour] = arrStartOfMatchDayMoreThan6Hour;
config.objOrderHomeCard[config.enumscinarioCode.preLineupsAnnouncedSubs] = arrPreLineupsAnnounced;
config.objOrderHomeCard[config.enumscinarioCode.live] = arrLive;
config.objOrderHomeCard[config.enumscinarioCode.pointsBeingCalculated] = arrPointsBeingCalculated;
config.objOrderHomeCard[config.enumscinarioCode.pointsOk] = arrPointsOk;
config.objOrderHomeCard[config.enumscinarioCode.endOfMatchDay] = arrEndOfMatchDay;
config.objOrderHomeCard[config.enumscinarioCode.longBreak] = arrLongBreak;
config.objOrderHomeCard[config.enumscinarioCode.postTournament] = arrPostTournament;
/** */
config.enumTrend = { '1': 'si-equal', '2': 'arrow-up', '3': 'arrow-down', '4': 'si-ucl-winner' };
config.enumFnTeamCard = [
    (objDate) => {
        let value = objDate.ms_Diff;
        //23hr 59min
        if (value > 86399000) {
            return {
                color: '#19C201', percent: 100,
                dtKey: 'days', trans: objDate.days == 1 ? "day" : "days",
                leftTime: objDate.days, altTrans: objDate.days == 1 ? "Day" : "Days",
                msDiff: value, maxTime: 1209599000,
                jPlusStartPosition: 50, jPercentageBy: 50
            };
        }
        return null;
    },
    (objDate) => {
        let value = objDate.ms_Diff;
        //86340000 23hr 59min
        if (value <= 86399000 && value > 3599000) {//3540000 as 59 min
            return {
                color: '#FA9263', percent: 50,
                dtKey: 'hours', trans: objDate.hours == 1 ? 'hour' : 'hours',
                leftTime: objDate.hours, altTrans: objDate.hours == 1 ? 'Hour' : 'Hours',
                msDiff: value, maxTime: 86399000,
                jPlusStartPosition: 25, jPercentageBy: 25
            };
        }
        return null;
    },
    (objDate) => {
        let value = objDate.ms_Diff;
        //59min 59sec
        if (value <= 3599000) {
            if (value > 0) {
                return {
                    color: '#FF0202', percent: 25,
                    dtKey: 'minutes', trans: objDate.minutes == 1 ? "minute" : "minutes",
                    leftTime: objDate.minutes, altTrans: objDate.minutes == 1 ? "Minute" : "Minutes",
                    msDiff: value, maxTime: 3599000,
                    jPlusStartPosition: 0, jPercentageBy: 25
                };
            }
            else {
                return {
                    color: '#FF0202', percent: 25,
                    dtKey: 'minutes', trans: objDate.minutes == 1 ? "minute" : "minutes",
                    leftTime: 0, altTrans: objDate.minutes == 1 ? "Minute" : "Minutes",
                    msDiff: 0, maxTime: 3599000,
                    jPlusStartPosition: 0, jPercentageBy: 25
                };
            }
        }
        return null;
    },];
config.playerStatusObj = {
    "NIS": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "NOT REGISTERED IN SQUAD",
        "transKey": "notRegistered",
        "playerInfoHeaderClass": "si-not-reg",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "notRegisteredTT"
    },
    "E": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "ELIMINATED",
        "transKey": "eliminated",
        "playerInfoHeaderClass": "si-eliminated",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "eliminatedTT"
    },
    "P": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "STARTING XI",
        "transKey": "startingXI",
        "playerInfoHeaderClass": "si-playing",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "startingXITT"
    },
    "B": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "BENCH",
        "transKey": "bench",
        "playerInfoHeaderClass": "si-bench",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "ontheBenchTT"
    },
    "R": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "SENT OF",
        "transKey": "sentOff",
        "playerInfoHeaderClass": "si-red-card",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "sentofTT"
    },
    "I": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "Injured",
        "transKey": "injured",
        "playerInfoHeaderClass": "si-injured",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "injuredTT"
    },
    "S": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "Suspended",
        "transKey": "suspended",
        "playerInfoHeaderClass": "si-suspended",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "suspendedTT"
    },
    "D": {
        "icon": "icon-ucl-close si-status-icon",
        "status": "Doughtfull",
        "transKey": "doubtful",
        "playerInfoHeaderClass": "si-doubtful",
        "playerJesreyClass": "si-injury-icon",
        "toolTipTrans": "doubtfulTT"
    }
};
config.enumMdCardStatus = { 'fixture': 'FX_CARD', 'points': 'PT_CARD' };
config.enumPlayerStatus = {
    'eliminated': 'E',
    'startingXI': 'P',
    'bench': 'B',
    'sentOff': 'R',
    'injured': 'I',
    'suspended': 'S',
    'doubtful': 'D',
    'notInSqad': 'NIS'
};
config.objCheckPlayerStatus = {};
config.objCheckPlayerStatus[config.enumPlayerStatus.eliminated] = { name: 'eliminated', class: 'si-eliminated' };
// config.objCheckPlayerStatus[config.enumPlayerStatus.startingXI] = { name: 'startingXI', class: '' };
// config.objCheckPlayerStatus[config.enumPlayerStatus.bench] = { name: 'bench', class: '' };
config.objCheckPlayerStatus[config.enumPlayerStatus.sentOff] = { name: 'sentOff', class: 'si-red-card' };
config.objCheckPlayerStatus[config.enumPlayerStatus.injured] = { name: 'injured', class: 'si-injured' };
config.objCheckPlayerStatus[config.enumPlayerStatus.suspended] = { name: 'suspended', class: 'si-suspended' };
config.objCheckPlayerStatus[config.enumPlayerStatus.doubtful] = { name: 'doubtful', class: 'si-doubtful' };
config.objCheckPlayerStatus[config.enumPlayerStatus.notInSqad] = { name: 'notRegistered', class: 'si-not-reg' };
config.timeoutForToast = 3000;
config.booster = {
    'wildcard': '1',
    'limitless': '2',
    'matchdayNotStartedWildcard': '3',
    'matchdayNotStartedLimitLess': '4'
};
config.matchDetailsStats = {
    "GS": {
        "icon": "si-goalIcn",
        "transKey": "GS"
    },
    "GA": {
        "icon": "si-assitsIcn",
        "transKey": "Assist"
    },
    "OG": {
        "icon": "si-ownGoalIcn",
        "transKey": "OG"
    },
    "PM": {
        "icon": "si-penaltyMissIcn si-penaltyRedIcn",
        "transKey": "PM"
    },
    "PS": {
        "icon": "si-penaltyGreenIcn si-penaltySaveIcn",
        "transKey": "PS"
    },
    "YC": {
        "icon": "si-yellowCrdIcn",
        "transKey": "YC"
    },
    "RC": {
        "icon": "si-redCrdIcn",
        "transKey": "RC"
    },
    "SS": {
        "icon": "si-savesIcn",
        "transKey": "SS"
    }
};
config.trackclickEvents = {
    'transfers': {
        "TrkEvent": "Page Meta",
        "TrkName": "My Team Transfer",
        "TrkPageName": "/uclfantasy/my-team/transfers/",
        "TrkPageType": "game entry",
        "TrkPageSubType": "fantasy transfer mode",
        "TrkPageFormat": "standard view"
    },
    'substitution': {
        "TrkEvent": "Page Meta",
        "TrkName": "My Team substitution",
        "TrkPageName": "/uclfantasy/my-team/substitutions/",
        "TrkPageType": "game entry",
        "TrkPageSubType": "fantasy substitutions mode",
        "TrkPageFormat": "standard view"
    },
    'playerCard': {
        "TrkEvent": "virtPath",
        "TrkName": "Fantasy - Player detail layer",
        "TrkPageName": "/uclfantasy/player-detail/",
        "TrkPageType": "player detail",
        "TrkPageSubType": "uclfantasy player",
        "TrkPageFormat": "instant view"
    },
    'fixturePopup': {
        "TrkEvent": "virtPath",
        "TrkName": "Fantasy - Upcoming fixtures layer",
        "TrkPageName": "/uclfantasy/upcoming-fixtures/",
        "TrkPageType": "match listing",
        "TrkPageSubType": "uclfantasy match calendar",
        "TrkPageFormat": "instant view"
    },
    'leagueInviewShare': {
        "TrkEvent": "virtPath",
        "TrkName": "League invite",
        "TrkPageName": "/uclfantasy/leagues/invite/",
        "TrkPageType": "share",
        "TrkPageSubType": "fantasy league invite",
        "TrkPageFormat": "instant view"
    },
    'leagueJoin': {
        "TrkEvent": "virtPath",
        "TrkName": "League join",
        "TrkPageName": "/uclfantasy/leagues/join/",
        "TrkPageType": "share",
        "TrkPageSubType": "fantasy league join",
        "TrkPageFormat": "instant view",
    },

};
config.gameName = "Fantasy Football";
config.ghGameName = "uclfantasy";
config.landingPageClients = ['fantasy', 'fifa'];
config.landingPageImageBase = config.BASE_DIR + "/static-assets/landing/{CLIENT_NAME}/graphics/images/"
config.DTImgUrl = config.isMobile ? (config.dreamteamImgBase + 'round{{PtGameday}}.jpg') : (config.dreamteamImgBase + 'round{{PtGameday}}_750x626.jpg');
config.DTDefaultImgUrl = config.isMobile ? (config.dreamteamImgBase + 'default_375x313.jpg') : (config.dreamteamImgBase + 'default_750x626.jpg');
config.teamOftheSeasonRoundNumber = 100;

config.cardConstants = {
    'card-create-team': {
        id: '-',
        name: 'Fantasy Football - Create Team',
        category: 'uclfantasy',
        //variant:'(new user/returning player/incomplete squad)',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-manage-team': {
        id: '-',
        name: 'Fantasy Football - Manage Team',
        category: 'uclfantasy',
        //variant:'(post draw/ready/full squad/issues)',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-players-in-play': {
        id: '-',
        name: 'Fantasy Football - Players in play',
        category: 'uclfantasy',
        //variant:'',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-substitutions': {
        id: '-',
        name: 'Fantasy Football - Substitutions',
        category: 'uclfantasy',
        //variant:'(ready/issues)',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-top-performer': {
        id: '-',
        name: 'Fantasy Football - Top Performer',
        category: 'uclfantasy',
        //variant:'',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-points-status': {
        id: '-',
        name: 'Fantasy Football - Points Status',
        category: 'uclfantasy',
        //variant:'',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-leagues': {
        id: '-',
        name: 'Fantasy Football - Leagues',
        category: 'uclfantasy',
        //variant:'(no leagues/ private leagues)',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-points': {
        id: '-',
        name: 'Fantasy Football - Points',
        category: 'uclfantasy',
        //variant:'(matchweek/season)',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    },
    'card-article': {
        id: '-',
        name: 'Fantasy Football - Article',
        category: 'uclfantasy',
        //variant:'{articleID}',
        // brand:'ucl',
        // list: 'hub-{page subtype}'
    }
}

config.maxLeaderboardPages = 20;
config.imgVersion = 6;
config.knoctOutGD = 9;

export default config;


// WEBPACK FOOTER //
// ./src/config.js